module.exports = __webpack_public_path__ + "static/globuli-911308ae829940eae6dfab9f0841b9ea.jpg";